module.exports = __webpack_public_path__ + "depart.svg?b9e6c633801db4df54422c659f758304";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/depart.svg
// module id = 157
// module chunks = 0